import React from 'react';

import Layout from '../../components/Layout';
import DISLandingPage from '../../components/asd/DISLandingPage';
import ASDBrowserPage from '../../components/asd/ASDBrowserPage';

import Page from '../../components/Page';
import about from './about.md';

const asdHeader = {
  aboutUrl: '/asdbrowser/about',
};

function disAsd() {
  return {
    title:
      'Whole-genome deep-learning analysis identifies contribution of' +
      ' noncoding mutations to autism risk',
    component: (
      <Layout headerOptions={asdHeader}>
        <DISLandingPage />
      </Layout>
    ),
  };
}

function asdBrowser() {
  return {
    title:
      'Whole-genome deep-learning analysis identifies contribution of' +
      ' noncoding mutations to autism risk',
    component: (
      <Layout headerOptions={asdHeader}>
        <ASDBrowserPage />
      </Layout>
    ),
  };
}

function aboutRoute() {
  return {
    title: about.title,
    component: (
      <Layout headerOptions={asdHeader}>
        <Page {...about} />
      </Layout>
    ),
  };
}

function genomePosition(params) {
  let chr = null;
  let startPosition = null;
  let endPosition = null;
  let gene = null;
  const tok = params.genomePosition.split(':');
  if (tok.length > 1) {
    // Genomic Range
    const range = tok[1].split('-');
    if (range.length) {
      // eslint-disable-next-line prefer-destructuring
      chr = tok[0];
      startPosition = parseInt(range[0], 10);
    }
    if (range.length > 1) {
      endPosition = parseInt(range[1], 10);
    }
  } else {
    // Search by Gene
    // eslint-disable-next-line prefer-destructuring
    gene = tok[0];
  }
  return {
    title:
      'Whole-genome deep-learning analysis identifies contribution of' +
      ' noncoding mutations to autism risk',
    component: (
      <Layout headerOptions={asdHeader}>
        <ASDBrowserPage
          chr={chr}
          startPosition={startPosition}
          endPosition={endPosition}
          gene={gene}
        />
      </Layout>
    ),
  };
}

// path: ['/dis_asd', '/asdbrowser', '/about', '/asdbrowser/:genomePosition'],
function action({ params, route, path }) {
  const routeIdx = route.path.indexOf(path.replace(/\/$/, ''));
  const routes = [disAsd, asdBrowser, aboutRoute];
  let realizedRoute;
  if (routeIdx < 0) realizedRoute = genomePosition(params);
  else realizedRoute = routes[routeIdx]();
  realizedRoute.chunk = ['asd'];
  return realizedRoute;
}

export default action;
